import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import v4 from 'uuid';
import { propBool, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import InputError from '../../Common/InputError';
import PlainInput from '../../Common/PlainInput';
const CategoryMiddleFieldsAndLabel = (props) => {
    const { check, disabled, especially, middleIsOther, middleName, other, otherMiddleClassName, wrapMiddleClassName, } = props;
    const wrapOnChange = useCallback((e) => {
        const { checked } = e.currentTarget;
        if (!checked) {
            especially.input.onChange(false);
        }
    }, [especially.input]);
    const id = useMemo(() => v4(), []);
    if (!middleIsOther) {
        return (_jsxs("div", Object.assign({ className: wrapMiddleClassName }, { children: [_jsx(PlainInput, { checked: check.input.value, className: 'mdc-checkbox__native-control', disabled: disabled, id: id, input: check.input, meta: check.meta, type: 'checkbox', wrapOnChange: wrapOnChange }), _jsx("label", Object.assign({ htmlFor: id }, { children: _jsx("span", { children: middleName }) }))] })));
    }
    return (_jsxs("div", Object.assign({ className: 'is-other is-display-block' }, { children: [_jsxs("div", Object.assign({ className: `${wrapMiddleClassName} pr0 is-display-flex alignItemCenter is-nowrap mt05 sp-mt0 sp-flex-direction-column sp-flex-align-start` }, { children: [_jsx(PlainInput, { checked: check.input.value, className: 'mdc-checkbox__native-control', disabled: disabled, id: id, input: check.input, meta: check.meta, type: 'checkbox' }), _jsx("label", Object.assign({ htmlFor: id }, { children: _jsx("span", { children: middleName }) })), _jsx(PlainInput, { className: `input-form-text asign-state is-after-select ${otherMiddleClassName} mt0`, disabled: !check.value, input: other.input, meta: other.meta, placeholder: 'その他' })] })), _jsx(InputError, { className: 'pr0 mt05', meta: other.meta })] })));
};
CategoryMiddleFieldsAndLabel.propTypes = {
    check: propShape().isRequired,
    disabled: propBool().isRequired,
    especially: propShape().isRequired,
    middleIsOther: propBool().isRequired,
    middleName: propStr().isRequired,
    other: propShape().isRequired,
    otherMiddleClassName: propStr().isRequired,
    wrapMiddleClassName: propStr().isRequired,
};
export default CategoryMiddleFieldsAndLabel;
